/*global $*/

import ko from 'knockout';

export function registerComponent() {
  ko.components.register('checkbox-chip', {
    template: `<label data-bind="visible: visible, html: text, click: remove"></label>`,
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new CheckboxChipViewModel(params, componentInfo);
      },
    },
  });
}

// eslint-disable-next-line no-unused-vars
function CheckboxChipViewModel(params, componentInfo) {
  var self = this;

  var initialText = params.text;

  self.text = ko.pureComputed(function () {
    return initialText;
  }, self);

  self.visible = ko.pureComputed(function () {
    return !!params.data();
  }, self);

  self.remove = function (data, event) {
    var $form = $(event.currentTarget).closest('form');
    params.data(false);
    $form.trigger('update');
  };
}
